export default __webpack_public_path__ + "static/palette-neutral-mapping-2e8a260a2304eae6e881583e0e1a16a0.png";